<template>
  <div
    id="sidebar"
    v-show="!isLoading"
  >
    <div>
      <div
        class="d-flex align-items-center justify-content-center px-2 logo-container"
      >
        <img
          class="w-75"
          src="/images/smartmatch-logo.png"
          alt="logo"
        >
      </div>
      <ProfileDetails
        @setIsLoading="setIsLoading"
      />
      <div class="btn-list text-center">
        <router-link
          :to="{ name: 'NewCampaignBlank',

          }"
          class="btn btn-sm btn-primary w-75"
          data-test="sidebar-new-campaign-button"
          append
        >
          New Campaign
        </router-link>
      </div>
      <div class="nav flex-sm-column">
        <TheNavigation
          v-if="!isLoading"
        />
      </div>
    </div>
    <div class="mt-auto pb-5 text-center">
      <div class="btn-list text-center mb-3">
        <a
          href="https://a.smartology.co/smartmatch-best-practice-content.pdf"
          type="button"
          class="btn btn-secondary w-75"
          target="_blank"
        >
          Best Practice Guide <i class="fa-light fa-download ml-3" />
        </a>
      </div>
      <a
        class="header-brand mx-auto"
        target="_blank"
        href="https://www.smartology.net/"
      >
        <img
          src="/images/logo.png"
          class="h-7"
          alt="Smartology"
        >
      </a>
      <ul class="list-inline list-inline-dots mb-0">
        <li class="list-inline-item">
          <a
            class="small"
            href="https://www.smartology.net/terms-of-service/"
            rel="noopener noreferrer"
            target="_blank"
          >Terms of Service</a>
        </li>
        <li class="list-inline-item">
          <a
            class="small"
            href="https://www.smartology.net/privacy-policy/"
            rel="noopener noreferrer"
            target="_blank"
          >Privacy Policy</a>
        </li>
      </ul>
      <ul class="list-inline list-inline-dots mb-0">
        <li class="list-inline-item">
          <a
            class="small"
            href="https://www.smartology.net/cookie-policy/"
            rel="noopener noreferrer"
            target="_blank"
          >Cookie Policy</a>
        </li>
        <li class="list-inline-item">
          <a
            class="small"
            href="https://www.smartology.net/frequently-asked-questions/"
            rel="noopener noreferrer"
            target="_blank"
          >FAQs</a>
        </li>
      </ul>
      <ul class="list-inline list-inline-dots mb-0">
        <li class="list-inline-item">
          <a
            class="small"
            href="https://www.smartology.net/content-policy/"
            rel="noopener noreferrer"
            target="_blank"
          >Content Policy</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TheNavigation from '@/components/TheNavigation';
import ProfileDetails from '@/modules/account/components/ProfileDetails';

export default {
  name: 'TheSidebar',

  components: {
    TheNavigation,
    ProfileDetails,
  },

  data() {
    return {
      isLoading: true,
      userAttributes: {
        name: '',
        organization: '',
        role: '',
      },
    };
  },
  methods: {
    setIsLoading(payload) {
      this.isLoading = payload;
    },
  },
};
</script>
<style lang="scss">
#sidebar {
  position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    -webkit-box-pack: justify;
    justify-content: space-between;
    z-index: 1010;
    width: 16.6667%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .logo-container {
      height: 150px;
    }
    .nav {
      margin-right: 1px;
    }
  }
  </style>
